import type { ParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Shared from '@/shared'
import SectionBar from '@/shared/components/SectionBar'
import { Caption } from '@/shared/components/typography'

interface ParkinglotModifyDateProps {
  modifyDate: ParkinglotDetail['modifyDate']
}

const ParkinglotModifyDateView = ({ modifyDate }: ParkinglotModifyDateProps) => {
  const infoDate = Shared.Utils.getModifiedDate(modifyDate)

  return (
    <div className="mt-[16px] w-full px-[16px]">
      <div className="flex h-[22px] w-full items-center justify-between">
        <Caption level="caption2" weight="regular" color="text070">
          정보 업데이트
        </Caption>
        <Caption level="caption2" weight="regular" color="text070">
          {infoDate}
        </Caption>
      </div>
      <SectionBar border="border-t-[1px]" className="mb-[24px] mt-[16px] border-dashed border-[#DEE4E9]" />
    </div>
  )
}

export default ParkinglotModifyDateView
